// Utility to lazy-load the Razorpay Checkout SDK from CDN.
// Returns the global `window.Razorpay` constructor.

const RZP_SCRIPT_URL = 'https://checkout.razorpay.com/v1/checkout.js';

let _promise = null;

export function loadRazorpay() {
    if (typeof window === 'undefined') return Promise.reject(new Error('Not in browser'));
    if (window.Razorpay) return Promise.resolve(window.Razorpay);
    if (_promise) return _promise;
    _promise = new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = RZP_SCRIPT_URL;
        s.async = true;
        s.onload = () => {
            if (window.Razorpay) resolve(window.Razorpay);
            else reject(new Error('Razorpay SDK failed to attach'));
        };
        s.onerror = () => reject(new Error('Failed to load Razorpay SDK'));
        document.body.appendChild(s);
    });
    return _promise;
}
